import { defineStore } from 'pinia'
import { IStore } from '@/system-modules/lock-screen/v1/core/interface/IStore'

export default defineStore('systemLockScreenStoreV1', {
  state: (): IStore => {
    return {
      locked: false,
    }
  },
})
